module.exports = __webpack_public_path__ + "img/l1.a2c6ef76.jpeg";